"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "barisciano": {
    "cdef8e98": [{
      "hkey": "161f4482",
      "slug": "san-martino",
      "name": "San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "picenze-san-martino": [{
      "hkey": "161f4482",
      "slug": "san-martino",
      "name": "San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "667ff9f1": [{
      "hkey": "31f54b4d",
      "slug": "barisciano",
      "name": "Barisciano",
      "primary": true,
      "skipSearch": false
    }],
    "villa-di-mezzo": [{
      "hkey": "31f54b4d",
      "slug": "barisciano",
      "name": "Barisciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;